import api from '.'

export const siteMonitoring = {
  create (siteId, data, success, fail) {
    api.authenticatedRequest('POST', `/sites/${siteId}/site-monitoring`, data, success, fail)
  },
  getForSite (siteId, success, fail) {
    api.authenticatedRequest('GET', `/sites/${siteId}/site-monitoring`, null, success, fail)
  },
  update (monitoringId, data, success, fail) {
    api.authenticatedRequest('PUT', `/site-monitoring/${monitoringId}`, data, success, fail)
  },
  delete (monitoringId, success, fail) {
    api.authenticatedRequest('DELETE', `/site-monitoring/${monitoringId}`, null, success, fail)
  }
}
